import { useState, useEffect } from "react";
import styled from "styled-components";

export default function TestimonialsSlider() {
  const testimonials = [
    {
      quote:
        "Lexi is an absolute genius behind the lens — she made me feel the most beautiful I’ve ever felt.",
      name: "Maggie · Maternity Session",
    },
    {
      quote:
        "Lexi captured our family perfectly — natural, comfortable, and full of joy. 10/10 recommend!",
      name: "The Gower Family · Lifestyle Session",
    },
    {
      quote:
        "She makes every shoot so fun and relaxed — hands down my favorite photographer!",
      name: "The Clough Family · Lifestyle Session",
    },
    {
      quote:
        "Creative, kind, and full of vision. Every session feels effortless and authentic.",
      name: "Kk · Couples & Creative Portraits",
    },
  ];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(
      () => setIndex((prev) => (prev + 1) % testimonials.length),
      6000 // every 6 seconds
    );
    return () => clearInterval(interval);
  }, [testimonials.length]);

  return (
    <SliderContainer>
      <QuoteWrapper key={index}>
        <Quote>“{testimonials[index].quote}”</Quote>
        <Name>{testimonials[index].name}</Name>
      </QuoteWrapper>

      <Dots>
        {testimonials.map((_, i) => (
          <Dot
            key={i}
            active={i === index}
            onClick={() => setIndex(i)}
            aria-label={`Go to testimonial ${i + 1}`}
          />
        ))}
      </Dots>
    </SliderContainer>
  );
}

// 🌿 Styled Components
const SliderContainer = styled.div`
  margin-top: 40px;
  text-align: center;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 20px;
  color: #3e3b33;
`;

const QuoteWrapper = styled.div`
  animation: fadeIn 1s ease;
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const Quote = styled.p`
  font-size: 1.1rem;
  line-height: 1.6;
  font-style: italic;
  margin-bottom: 10px;
`;

const Name = styled.p`
  font-size: 0.95rem;
  letter-spacing: 0.3px;
  opacity: 0.8;
`;

const Dots = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: center;
  gap: 8px;
`;

const Dot = styled.button`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: none;
  background-color: ${(props) => (props.active ? "#3e3b33" : "#b0a898")};
  opacity: ${(props) => (props.active ? "1" : "0.6")};
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    opacity: 0.9;
  }
`;
